module.exports = __webpack_public_path__ + "img/link-expired.5e86f506.png";